import React from "react";
import {version} from '../../../package.json';
import { Container, Row } from "reactstrap";
import PropTypes from "prop-types";
import './style.css';

class Footer extends React.Component {
  render() {
    return (
      <footer
        className={"footer" + (this.props.default ? " footer-default" : "")}
      >
        <Container fluid={this.props.fluid ? true : false}>
          <Row>
            <nav className="footer-nav">
              <ul>
                <li>
                  <a href="https://www.digifarma.com.br/#contato" target="_blank" title="Contato">
                    <i className="fas fa-headset"/>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/Digifarma/" target="_blank" title="Facebook">
                    <i className="fab fa-facebook-square"/>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/Digifarma/" target="_blank" title="Instagram">
                    <i className="fab fa-instagram"/>
                  </a>
                </li>
              </ul>
            </nav>
            <div className="credits ml-auto">
              <span className="copyright">              
                &copy; Copyright {1900 + new Date().getYear()}, {" "} Digifarma - Todos os Direitos Reservados - {'V ' + version} 
              </span>
                                     
            </div>
          </Row>
        </Container>
      </footer>
    );
  }
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool
};

export default Footer;